var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCurrency),expression:"showCurrency"}],staticClass:"currency_code"},[_vm._v(_vm._s(_vm.currency))]),_vm._v(" "+_vm._s(_vm.symbol)+_vm._s(_vm.displayValue)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }